import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-session-warning',
  templateUrl: './session-warning.component.html',
  styleUrls: ['./session-warning.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatButtonModule]
})
export class SessionWarningComponent implements OnInit {
  timeLeft: number = 5 * 60;
  displayTime: string = '00:00';
  interval: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private _dialogRef: MatDialogRef<SessionWarningComponent>) {}

  ngOnInit() {
    this.timeLeft = this.data.timeLeft / 1000;

    this.interval = setInterval(() => {
      this.timeLeft--;
      this.formatTime(this.timeLeft);
      if (this.timeLeft <= 0) {
        clearInterval(this.interval);
        this._dialogRef.close('logout');
      }
    }, 1000);
  }

  extendSession() {
    clearInterval(this.interval);
    this._dialogRef.close('extend');
  }

  logout() {
    clearInterval(this.interval);
    this._dialogRef.close('logout');
  }

  formatTime(seconds: number) {
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    this.displayTime = `${this.pad(minutes)}:${this.pad(secs)}`;
  }

  pad(value: number): string {
    return value.toString().padStart(2, '0');
  }
}
